import { buildArticle } from "./_articleBuilder";

export default buildArticle({
  slug: "can-tms-be-considered-after-multiple-antidepressants",
  title: "Can TMS Be Considered After Multiple Antidepressants?",
  description:
    "Yes. TMS is FDA-cleared for treatment-resistant depression and may be considered after multiple antidepressant trials. Learn about eligibility and what to discuss.",
  keywords:
    "TMS after antidepressants, TMS treatment-resistant depression, TMS eligibility, multiple antidepressants failed",
  badge: "Educational Article",
  heroTitle: "Can TMS Be Considered After Multiple Antidepressants?",
  heroSubtitle:
    "Yes. TMS is FDA-cleared for treatment-resistant depression — depression that hasn't responded adequately to prior antidepressant trials. Having tried multiple medications doesn't disqualify you; it may be exactly why TMS is worth considering.",
  sections: [
    {
      heading: "TMS Was Developed for This Situation",
      body: "TMS exists specifically for people who haven't gotten adequate relief from oral antidepressants. If you've tried multiple medications without success, that's not a reason to rule out TMS — it's often the reason TMS is appropriate to consider.",
    },
    {
      heading: "What 'Adequate Trial' Means",
      body: "Insurance and clinical criteria often reference adequate trials — meaning the medication was taken at a sufficient dose for a sufficient duration. A rough list of what you've tried, when, and what happened is helpful for both clinical and insurance purposes.",
    },
    {
      heading: "Prior TMS Doesn't Disqualify You Either",
      body: "If you've had TMS before, that doesn't automatically disqualify you from another course or from SAINT®. Some insurers require a waiting period between courses. Bring the approximate end date of your last treatment to the consultation.",
      callout: true,
    },
    {
      heading: "Eligibility Is Clinical",
      body: "Whether TMS is appropriate is determined through clinical evaluation, not by a website. Your full history — medications, prior treatments, current symptoms, and health history — is part of that determination.",
    },
  ],
  faq: [
    {
      question: "How many antidepressants do I need to have tried?",
      answer:
        "Clinical criteria often reference two or more adequate trials. The determination is made by a clinician based on your full history, not by a fixed number alone.",
    },
    {
      question: "Do I need to stop my current medication before TMS?",
      answer:
        "No. TMS may be used alongside current medication. Do not stop or change medication without discussing it with your prescribing provider.",
    },
  ],
  related: [
    {
      title: "When Antidepressants Aren't Enough",
      href: "/when-antidepressants-dont-work",
    },
    {
      title: "What Is Treatment-Resistant Depression?",
      href: "/what-is-treatment-resistant-depression",
    },
    { title: "If You've Had TMS Before", href: "/already-tried-tms" },
  ],
  finalCtaText:
    "If you've tried multiple antidepressants, TMS may be worth exploring. Speak with our team about your history.",
});
